import React, { useMemo } from 'react';
import { useSelector } from "react-redux";
import { Row, Col } from 'react-bootstrap';

const AssignedCustomerList = props => {
    const { isRequesting, assignedCustomerIds, handleUnassignCustomer } = props;

    const { payload: farmCustomerList, isRequesting: farmCustomerRequsting } = useSelector((state => state.customer.farmCustomerList));

    const getFarmListById = (farmCustomerList, assignedCustomerIds) => {
        const filteredCustomerList = farmCustomerList.filter(item => assignedCustomerIds.indexOf(item.customer_uuid) >= 0);

        const CustomerListByFarmId = filteredCustomerList.reduce((objectsByKeyValue, obj) => {
            const value = obj.farm_uuid;
            objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
            return objectsByKeyValue;
        }, {});

        return CustomerListByFarmId;
    }

    const CustomerListByFarmId = useMemo(() => getFarmListById(farmCustomerList, assignedCustomerIds), [farmCustomerList, assignedCustomerIds]);

    return (isRequesting || farmCustomerRequsting || assignedCustomerIds.length === 0
        ? <Col className="no-item-found">{isRequesting ? "Loading..." : "This user does not belong to any customers"}</Col>
        : <Col className="assigned-farms">
            {Object.keys(CustomerListByFarmId).map((farmId, index) => {
                const farmInfo = CustomerListByFarmId[farmId] && CustomerListByFarmId[farmId].length > 0 ?
                    CustomerListByFarmId[farmId][0] : { farm_name: "Unknown" };
                const color = "#002653";
                return farmInfo && <React.Fragment key={index}>
                    <Row className="field-title">
                        <Col className="m-auto">
                            <div className="splitter" style={{ background: color }} />
                        </Col>
                        <div style={{ color: color, borderColor: color }}
                            className="type d-flex">
                            <p className="name">{farmInfo.farm_name ? farmInfo.farm_name : 'Unknown'}</p>
                        </div>
                        <Col className="m-auto">
                            <div className="splitter" style={{ background: color }} />
                        </Col>
                    </Row>
                    <Row>
                        {CustomerListByFarmId[farmId].map(item => <div key={item.customer_uuid} className="farm-title d-flex"
                            style={{ background: color }}  >
                            <p className="name">{item.customer_name}</p>
                            <i className="fa fa-times-circle" aria-hidden="true" title="Unselect"
                                onClick={() => handleUnassignCustomer(item.customer_uuid)}></i>
                        </div>
                        )}
                    </Row>
                </React.Fragment>
            })}
        </Col >
    )
};


export default AssignedCustomerList;